<template>
  <Page :video="$jmsPath($jms('21days.video'))" :overlay="0.25">
    <v-sheet color="transparent" dark>
      <v-container class="px-0 py-0 my-md-12" style="max-width: 75rem">
        <v-row class="h-100" no-gutters>
          <v-col v-show-timeout="[0, 'slide-y']" cols="12" md="5" class="pa-6 rounded text-overlay" align-self="center">
            <h1
              v-html="$options.filters?.markdown($jms('21days.title'))"
              class="text-h4 text-md-h3 mb-3 mb-md-6"
            ></h1>
            <div v-html="$options.filters?.markdown($jms('21days.body'))" class="mb-4"></div>
            <v-btn
              :to="{ name: 'contact' }"
              color="primary"
              block
              x-large
            >
              {{ $jms('21days.cta') }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="d-none d-md-flex align-center justify-center"></v-col>
          <v-col cols="12" md="1" class="d-none d-md-flex"></v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </Page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Page from '@/components/Page.vue'
import Sticky from '@/components/Sticky.vue'

@Component({
  components: {
    Page,
    Sticky,
  }
})
export default class TwentyOneDaysView extends Vue {

}
</script>

